import { List, Stack } from '@mui/material';
import { useAdminUser } from 'src/legacy/hooks/useAdminUser';
import { useLocales } from 'src/legacy/locales';

import type { NavSectionProps } from '../types';

import NavList from './NavList';
import { StyledSubheader } from './styles';

const NavSectionVertical = ({ data, sx, ...other }: NavSectionProps) => {
  const { translate } = useLocales();
  const { isAdmin } = useAdminUser();

  return (
    <Stack sx={sx} {...other}>
      {data
        .filter((group) => (isAdmin ? true : !group.isAdmin))
        .map((group) => {
          const key = group.subheader || group.items[0].title;

          return (
            <List disablePadding key={key} sx={{ px: 2 }}>
              {group.subheader && (
                <StyledSubheader disableSticky>{`${translate(
                  group.subheader
                )}`}</StyledSubheader>
              )}

              {group.items
                .filter((group) => (isAdmin ? true : !group.isAdmin))
                .map((list) => (
                  <NavList
                    data={list}
                    depth={1}
                    hasChild={!!list.children}
                    key={list.title + list.path}
                  />
                ))}
            </List>
          );
        })}
    </Stack>
  );
};

export default NavSectionVertical;
